import i18n from '@dms/i18n';

import {getSafely} from 'shared/web';

const ATTRIBUTE_LABEL_KEYS: Record<string, string> = {
  MAKE: 'entity.vehicle.labels.make',
  MODEL_FAMILY: 'entity.vehicle.labels.modelFamily',
  MODEL: 'entity.vehicle.labels.model',
  BODY_STYLE: 'entity.vehicle.labels.carStyle',
  FUEL_TYPE: 'entity.vehicle.labels.fuel',
  CONDITION: 'entity.vehicle.labels.condition',
  YEAR: 'entity.vehicle.labels.year',
  MILEAGE: 'entity.vehicle.labels.mileage',
  PRICE: 'general.labels.price',
  DAYS_IN_STOCK: 'entity.salesCampaign.labels.stockAgeDays',
  STOCK_IN_DATE: 'entity.vehicle.labels.overview.stockInDate',
  BRANCH: 'entity.branch.labels.branch',
  SALE_PRESET: 'entity.vehicle.labels.salePreset',
  TAGS: 'entity.salesCampaign.labels.vehicleTag',
  VEHICLE_TYPE: 'entity.vehicle.labels.type',
};

// Labels a BE attribute code of the vehicle selection catalog; a code this FE does not know yet
// (a newer BE) is shown as it is.
export const getVehicleSelectionAttributeLabel = (attribute: string) => {
  const labelKey = getSafely(ATTRIBUTE_LABEL_KEYS, attribute);

  return labelKey ? i18n.t(labelKey) : attribute;
};
